import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-gray-900 min-h-screen w-full" }
const _hoisted_2 = { class: "px-4 py-8 mx-auto container" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-900 text-white p-4 rounded-lg mb-6"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center items-center py-10"
}
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileHeader = _resolveComponent("ProfileHeader")!
  const _component_ProfileTabs = _resolveComponent("ProfileTabs")!
  const _component_ProfileProducts = _resolveComponent("ProfileProducts")!
  const _component_ProfileRatings = _resolveComponent("ProfileRatings")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        class: "flex items-center text-gray-400 hover:text-blue-400 mb-6 transition-colors"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "mr-2" }, "←", -1),
        _createTextVNode(" Nazad na oglas ")
      ])),
      (_ctx.showMainLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_ctx.user)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_ProfileHeader, {
                  user: _ctx.user,
                  following: _ctx.following,
                  "followers-count": _ctx.followersCount,
                  "is-loading": _ctx.isLoading,
                  onToggleFollow: _ctx.handleToggleFollow
                }, null, 8, ["user", "following", "followers-count", "is-loading", "onToggleFollow"]),
                _createVNode(_component_ProfileTabs, {
                  "active-tab": _ctx.activeTab,
                  onChangeTab: _ctx.handleTabChange
                }, null, 8, ["active-tab", "onChangeTab"]),
                (_ctx.activeTab === 'products')
                  ? (_openBlock(), _createBlock(_component_ProfileProducts, {
                      key: 0,
                      "user-id": _ctx.user.id,
                      username: _ctx.user.username,
                      "user-city": _ctx.user.city
                    }, null, 8, ["user-id", "username", "user-city"]))
                  : (_ctx.activeTab === 'ratings')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.showRatingsLoader)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
                              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
                            ])))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_ProfileRatings, {
                                username: _ctx.user.username,
                                ratings: _ctx.filteredRatings,
                                stats: _ctx.ratingStats || _ctx.defaultRatingStats,
                                loading: false,
                                "current-page": _ctx.ratingCurrentPage,
                                meta: _ctx.ratingsMeta || _ctx.defaultMeta,
                                "user-role": _ctx.ratingUserRole,
                                "rating-filter": _ctx.ratingFilter,
                                "auth-required": _ctx.authRequired,
                                onChangeRole: _ctx.changeRatingRole,
                                onChangePage: _ctx.changeRatingPage,
                                onChangeFilter: _ctx.changeRatingFilter
                              }, null, 8, ["username", "ratings", "stats", "current-page", "meta", "user-role", "rating-filter", "auth-required", "onChangeRole", "onChangePage", "onChangeFilter"])
                            ]))
                      ]))
                    : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}